const TYPE = {
	ASSIGNMENT: "AssignmentExpression", // Represents an assignment operation, such as x = 5.
	EXPRESSION: "ArrayExpression", // Represents an array literal ([1, 2, 3]).
	BINARY: "BinaryExpression", // BinaryExpression: Represents a binary operation or an expression involving two operands and an operator.
	BOOLEAN: "BooleanLiteral", // BooleanLiteral: Represents a boolean value.
	BLOCK: "BlockStatement", // Represents a block of code enclosed in curly braces ({ ... }).
	CALL: "CallExpression", // Represents a function call expression (functionName(arg1, arg2)).
	CONDITIONAL: "ConditionalExpression", // Represents a conditional expression (condition ? trueValue : falseValue).
	DECLARATION: "FunctionDeclaration", // Represents a function declaration (function functionName(arg1, arg2) { ... }).
	IDENTIFIER: "Identifier", // Represents an identifier or variable name in the code.
	IF_STATEMENT: "IfStatement", // Represents an if statement (if (condition) { ... }).
	LOGICAL: "LogicalExpression", // Represents logical operations (&&, ||).
	NUMERIC: "NumericLiteral", // Represents a numeric value.
	MEMBER: "MemberExpression", // Represents accessing a member of an object or array (object.property, array[index]).
	OBJECT: "ObjectExpression", // Represents an object literal ({ prop1: value1, prop2: value2 }).
	REGEX: "RegexExpression", // Represents a Regex expression.
	STRING: "StringLiteral", // Represents a string value.
	UNARY: "UnaryExpression", // Represents unary operations, like negation or logical negation (-x, !isTrue).
	VARIABLE: "VariableDeclaration", // Represents variable declarations (var x = 5;).
	WHILE: "WhileStatement", // Represents a while loop statement (while (condition) { ... }).
};

function generateAST(tokens) {
	let index = 0;

	const precedence = {
		OR: 1,
		AND: 2,
		NOT: 3,
		">": 4,
		">=": 4,
		"<": 4,
		"<=": 4,
		":": 4,
	};

	const isUndefinedIn = tokens?.some((token) => token.type === "undefined");
	if (isUndefinedIn) throw new Error("Syntax error. Undefined token present.");

	function parseExpression() {
		let left = parseTerm();
		while (index < tokens.length && precedence[tokens[index].value] >= 1) {
			const operator = tokens[index++];
			if (operator.value === "NOT") {
				left = { type: TYPE.LOGICAL, operator: operator.value, right: parseTerm() };
			} else {
				let right = parseTerm();
				if (index < tokens.length && precedence[tokens[index].value] > precedence[operator.value]) {
					right = parseBinaryExpression(right);
				}
				left = { type: TYPE.LOGICAL, operator: operator.value, left, right };
			}
		}
		return left;
	}

	function parseTerm() {
		let left = parseFactor();

		while (index < tokens.length && precedence[tokens[index].value] >= 2) {
			left = parseBinaryExpression(left);
		}

		return left;
	}

	function parseBinaryExpression(left) {
		const operator = tokens[index++];
		let right = parseFactor();

		while (index < tokens.length && precedence[tokens[index].value] > precedence[operator.value]) {
			right = parseBinaryExpression(right);
		}

		return {
			type: TYPE.BINARY,
			operator: operator.value,
			left,
			right,
		};
	}

	function parseFactor() {
		const token = tokens[index++];

		if (token?.type === "separator") {
			if (token.value === "(" || token.value === "[") {
				const closingToken = token.value === "(" ? ")" : "]";
				const expression = parseExpression();
				if (tokens?.[index++]?.value !== closingToken) {
					throw new Error("Syntax error");
				}
				return expression;
			}
		}

		switch (token?.type) {
			case "boolean":
				return { type: TYPE.BOOLEAN, value: Boolean(token?.value) };
			case "identifier":
				return { type: TYPE.IDENTIFIER, value: token?.value?.toString() };
			case "number":
				return { type: TYPE.NUMERIC, value: Number(token.value) };
			case "string": {
				const type = token.value.includes("/") ? TYPE.REGEX : TYPE.STRING;
				return { type, value: token.value };
			}

			default:
		}

		if (token.value === "NOT") {
			return { type: TYPE.LOGICAL, operator: token.value, right: parseExpression() };
		}

		throw new Error("Invalid parameter: " + token);
	}

	return parseExpression();
}

export { generateAST };
